<form #crudForm="ngForm">
  <textarea class="form-control" [(ngModel)]="value" name="notes" style="height: 350px;"></textarea>
</form>
